
import React from 'react';
import { motion } from 'framer-motion';
import { ParticleField } from '@/components/ui/premium';

interface HeroBackgroundProps {
  mousePosition: { x: number; y: number };
  isMobile: boolean;
}

export const HeroBackground = ({ mousePosition, isMobile }: HeroBackgroundProps) => {
  return (
    <>
      {/* Interactive particle background */}
      <ParticleField 
        density="medium" 
        interactive 
        colors={['rgba(236, 28, 36, 0.6)', 'rgba(232, 88, 101, 0.4)', 'rgba(153, 183, 175, 0.5)', 'rgba(242, 204, 206, 0.3)']}
      />

      {/* Dynamic gradient background with #99B7AF and red */}
      <motion.div
        className="absolute inset-0"
        animate={{
          background: [
            'linear-gradient(135deg, rgba(236, 28, 36, 0.1) 0%, rgba(153, 183, 175, 0.1) 30%, transparent 50%, rgba(232, 88, 101, 0.1) 100%)',
            'linear-gradient(225deg, rgba(232, 88, 101, 0.1) 0%, transparent 30%, rgba(153, 183, 175, 0.1) 50%, rgba(242, 204, 206, 0.1) 100%)',
            'linear-gradient(315deg, rgba(242, 204, 206, 0.1) 0%, rgba(153, 183, 175, 0.1) 30%, transparent 50%, rgba(236, 28, 36, 0.1) 100%)'
          ]
        }}
        transition={{ duration: 8, repeat: Infinity, ease: 'linear' }}
      />

      {/* Floating orbs with enhanced #99B7AF integration and red */}
      {!isMobile && (
        <>
          <motion.div
            className="absolute top-20 left-20 w-64 h-64 rounded-full opacity-20 blur-3xl"
            style={{
              background: `radial-gradient(circle, rgba(153, 183, 175, 0.8), rgba(236, 28, 36, 0.6), transparent 70%)`,
              x: mousePosition.x * 0.5,
              y: mousePosition.y * 0.5
            }}
            animate={{
              scale: [1, 1.2, 1],
              opacity: [0.2, 0.4, 0.2]
            }}
            transition={{ duration: 4, repeat: Infinity, ease: 'easeInOut' }}
          />
          <motion.div
            className="absolute bottom-20 right-20 w-48 h-48 rounded-full opacity-30 blur-2xl"
            style={{
              background: `radial-gradient(circle, rgba(153, 183, 175, 0.9), rgba(232, 88, 101, 0.7), transparent 70%)`,
              x: mousePosition.x * -0.3,
              y: mousePosition.y * -0.3
            }}
            animate={{
              scale: [1, 1.1, 1],
              opacity: [0.3, 0.5, 0.3]
            }}
            transition={{ duration: 5, repeat: Infinity, ease: 'easeInOut', delay: 1 }}
          />
          {/* New floating orb with pure #99B7AF */}
          <motion.div
            className="absolute top-1/2 left-10 w-32 h-32 rounded-full opacity-25 blur-2xl"
            style={{
              background: `radial-gradient(circle, rgba(153, 183, 175, 1), transparent 60%)`,
              x: mousePosition.x * 0.2,
              y: mousePosition.y * 0.2
            }}
            animate={{
              scale: [1, 1.3, 1],
              rotate: [0, 180, 360],
              opacity: [0.25, 0.4, 0.25]
            }}
            transition={{ duration: 7, repeat: Infinity, ease: 'easeInOut', delay: 2 }}
          />
        </>
      )}
    </>
  );
};
